export const EUR = "€";
